import React, { useRef, useState, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Footer from '../../components/Footer';
import Header from '../../components/Header';
import HeaderInfo from '../../components/HeaderInfo';
import Notification from '../../components/Notification';
import TransactionList from './Transaction';
import { dateFormat } from '../../utils/formattedDate';
import { transactionListApi } from '../../api/usersApi';
import EditTransaction from '../../components/Transaction/EditTransaction';

import '../../assets/css/Transaction.css'
import '../../assets/css/Popup.css'

const Transaction = () => {
    const userEditRef = useRef();
    const debounceRef = useRef(null);
    const [menuActive, setMenuActive] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [isEditTransaction, setEditTransaction] = useState(false)
    const [selectedTransaction, setSelectedTransaction] = useState({})
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [transactionList, setTransactionList] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [filterTransaction, setFilterTransaction] = useState({
        userType: [],
        plan: [],
        amount: '',
        date: '',
        status: [],
    })

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userEditRef?.current && !userEditRef?.current.contains(event.target)) {
                setEditTransaction(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setIsLoading(true);
        setIsLoadingData(true);
        if (debounceRef?.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            fetchTransaction();
        }, 1500);

        return () => clearTimeout(debounceRef.current);
    }, [currentPage, searchQuery, filterTransaction])

    useEffect(() => {
        setCurrentPage(1);
    }, [filterTransaction, searchQuery]);

    const transactionApi = async () => {
        const data = await transactionListApi({
            page: currentPage || 1,
            limit: 10,
            name: searchQuery?.toLowerCase() || undefined,
            userType: filterTransaction?.userType?.map((item) => item?.toString()),
            plan: filterTransaction?.plan?.map((item) => item?.toString()),
            status: filterTransaction?.status?.map((item) => item?.toString()),
            dateFrom: (filterTransaction?.date?.from !== '' && filterTransaction?.date?.from !== undefined && filterTransaction?.date?.from) ? dateFormat(filterTransaction?.date?.from) : undefined,
            dateTo: (filterTransaction?.date?.to !== '' && filterTransaction?.date?.to !== undefined && filterTransaction?.date?.to) ? dateFormat(filterTransaction?.date?.to) : undefined,
        }, setIsLoadingData);
        return data;
    }

    const fetchTransaction = async () => {
        setIsLoading(false);
        try {
            setIsLoading(true)
            setIsLoadingData(true)
            const data = await transactionApi()
            if (data?.list?.length <= 0) {
                setIsLoadingData(false)
            }
            setTransactionList(data?.list);
            setTotalPage(data?.totalPage)
            setIsLoading(false);
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            setIsLoadingData(false)
        }
    };

    return (
        <div className='main-wrapper'>
            <Header activePage="transactions" menuActive={menuActive} setMenuActive={setMenuActive} />
            <div className="main-content">
                <div className={`content-wrapper`}>
                    <HeaderInfo title='Transactions' description='Stay on top of every financial transaction in real time.' />
                    <div className="transactionContent">
                        <Routes basename="/transactions">
                            <Route
                                path="/"
                                element={
                                    <TransactionList
                                        setShowNotification={setShowNotification}
                                        setNotificationMessage={setNotificationMessage}
                                        userEditRef={userEditRef}
                                        setEditTransaction={setEditTransaction}
                                        transactionList={transactionList}
                                        setSelectedTransaction={setSelectedTransaction}
                                        setIsLoading={setIsLoading}
                                        isLoading={isLoading}
                                        isLoadingData={isLoadingData}
                                        setIsLoadingData={setIsLoadingData}
                                        setCurrentPage={setCurrentPage}
                                        currentPage={currentPage}
                                        totalPage={totalPage}
                                        setSearchQuery={setSearchQuery}
                                        searchQuery={searchQuery}
                                        setFilterTransaction={setFilterTransaction}
                                        filterTransaction={filterTransaction}
                                    />
                                } >
                            </Route>
                        </Routes>
                    </div>
                </div>
                <Footer menuActive={menuActive} />
            </div>
            {
                showNotification &&
                <Notification
                    showNotification={showNotification}
                    notificationMessage={notificationMessage}
                    setShowNotification={setShowNotification}
                />
            }
            <EditTransaction
                setEditTransaction={setEditTransaction}
                ref={userEditRef}
                selectedTransaction={selectedTransaction}
                isEditTransaction={isEditTransaction}
                transactionApi={transactionApi}
                setTransactionList={setTransactionList}
                setShowNotification={setShowNotification}
                setNotificationMessage={setNotificationMessage}
            />
        </div>
    )
}

export default Transaction
